// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"512":"c607a36c","787":"81799df8","879":"ba65727a"}[chunkId] + ".chunk.js";
};